import styled from 'styled-components'

export const CourseName = styled.div`
  font-family: roboto;
  font-size: 18px;
  font-weight: 700;
  margin: 24px 20px;
`

export const BackButton = styled.div`
  font-family: roboto;
  font-size: 14px;
  font-weight: 700;
  margin: 24px 20px 0;
  background-color: #ffffff1a;
  border-radius: 8px;
  padding: 10px 12px;
  cursor: pointer;
  transition: 200ms;
  svg {
    margin-right: 6px;
  }
  &:hover {
    background-color: #ffffff2b;
  }
`

export const LessonsCount = styled.div`
  margin: 0 20px 16px;
  font-family: roboto;
  font-size: 14px;
`
